import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecondPartActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 18,
			stroke: "#BCA4FF",
			strokeDasharray: "7 7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 14,
			fill: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1815 15.675C21.1915 15.705 21.2131 15.7767 21.2465 15.89C21.2798 16.0033 21.3131 16.14 21.3465 16.3C21.3798 16.4567 21.4098 16.6267 21.4365 16.81C21.4631 16.99 21.4765 17.1633 21.4765 17.33C21.4765 17.6733 21.4198 17.9717 21.3065 18.225C21.1931 18.4783 21.0465 18.6883 20.8665 18.855C20.6865 19.0183 20.4815 19.14 20.2515 19.22C20.0248 19.3 19.7965 19.34 19.5665 19.34C19.3398 19.34 19.1315 19.3133 18.9415 19.26C18.7548 19.2033 18.5798 19.1283 18.4165 19.035C18.4465 19.325 18.4698 19.6133 18.4865 19.9C18.5031 20.1867 18.5148 20.49 18.5215 20.81C18.5281 21.1267 18.5315 21.47 18.5315 21.84C18.5348 22.21 18.5348 22.6233 18.5315 23.08H17.3015V21.87C17.3015 21.4767 17.2948 21.0617 17.2815 20.625C17.2715 20.185 17.2415 19.7233 17.1915 19.24C17.1415 18.7567 17.0648 18.25 16.9615 17.72C16.8581 17.19 16.7148 16.6367 16.5315 16.06L17.7165 15.68L17.9215 16.29C17.9381 16.34 17.9648 16.42 18.0015 16.53C18.0415 16.6367 18.0931 16.7583 18.1565 16.895C18.2198 17.0283 18.2948 17.1667 18.3815 17.31C18.4715 17.45 18.5748 17.58 18.6915 17.7C18.8081 17.8167 18.9381 17.9133 19.0815 17.99C19.2281 18.0633 19.3898 18.1 19.5665 18.1C19.6065 18.1 19.6631 18.0933 19.7365 18.08C19.8131 18.0667 19.8881 18.035 19.9615 17.985C20.0381 17.9317 20.1048 17.8533 20.1615 17.75C20.2181 17.6467 20.2465 17.5067 20.2465 17.33C20.2465 17.2267 20.2381 17.115 20.2215 16.995C20.2048 16.8717 20.1831 16.7533 20.1565 16.64C20.1331 16.5233 20.1065 16.415 20.0765 16.315C20.0498 16.2117 20.0248 16.125 20.0015 16.055L21.1815 15.675Z",
			fill: "white"
		})
	]
});
export default SvgSecondPartActive;
